import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { LayerHotkeyType } from '../../type';

export const layerCloneItem = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;
    let disabled = !layer;

    if (disabled) return null;
    if (activeLayer) {
        disabled = framework.service.behavior.get(activeLayer)?.checkDisableClone?.(activeLayer) ?? false;
    }

    const type = LayerHotkeyType.CLONE;
    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.createCopy),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            framework.service.hotkey.__emit(type, { from: 'context-menu' });
        },
    };

    return item;
};
